import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export const getCardType = async (query) => {
  try {
    let res = await Api.get("/card-type", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getCardTypeById = async (id) => {
  try {
    let res = await Api.get("/card-type/" + id);

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const createCardType = async (data) => {
  try {
    let res = await Api.post("/card-type", data);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const updateCardType = async (id, data) => {
  try {
    let res = await Api.patch("/card-type/" + id, data);

    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const deleteCardType = async (id) => {
  try {
    let res = await Api.delete("/card-type/" + id);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

